import React, { FC, useContext } from 'react'

import { useFormContext } from 'react-hook-form'

import { AppContext } from 'Const'
import useToggle from 'Hooks/useToggle'
import { useInquiry } from 'Utils/inquiry'

import ErrorMessage from 'Components/ErrorMessage'

import FormErrors from '../../FormErrors'
import PasswordField from '../PasswordField'

const Details: FC = () => {
  const { register, errors } = useFormContext()
  const [wantPassword, toggleWantPassword] = useToggle()
  const { currentLocation, account } = useContext(AppContext)
  const loginState = useInquiry(account.customerAccountsState)

  return (
    <div>
      <div className="checkout-contact-flow__name-row">
        <div className="checkout-contact-flow__name-col">
          <div className="form-group d-flex align-items-center">
            <label className="col-sm-4 mb-0" htmlFor="customer-first-name">
              First Name
            </label>
            <input
              ref={register({ required: 'First name is required' })}
              required
              autoComplete="cc-given-name"
              className="form-control"
              id="customer-first-name"
              name="firstName"
              placeholder="Enter your first name..."
              type="text"
            />
            <ErrorMessage as={FormErrors} errors={errors} name="firstName" />
          </div>
        </div>

        <div className="checkout-contact-flow__name-col">
          <div className="form-group d-flex align-items-center">
            <label className="col-sm-4 mb-0" htmlFor="customer-last-name">
              Last Name
            </label>
            <input
              ref={register({ required: 'Last name is required' })}
              required
              autoComplete="cc-family-name"
              className="form-control"
              id="customer-last-name"
              name="lastName"
              placeholder="Enter your last name..."
              type="text"
            />
            <ErrorMessage as={FormErrors} errors={errors} name="lastName" />
          </div>
        </div>
      </div>

      <div className="form-group d-flex align-items-center">
        <label className="col-sm-4 mb-0" htmlFor="customer-email">
          Email
        </label>
        <input
          ref={register({
            required: 'Email is required',
            pattern: {
              value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              message: 'Email incorrect',
            },
          })}
          autoComplete="email"
          className="form-control mb-0"
          id="customer-email"
          name="email"
          placeholder="Enter your email..."
          required={false}
          type="email"
        />
        <ErrorMessage as={FormErrors} errors={errors} name="email" />
      </div>

      <div className="custom-control / custom-checkbox / checkout-contact-flow__checkbox">
        <input
          ref={register}
          defaultChecked
          className="custom-control-input"
          id="customer-subscribed"
          name="subscribed"
          type="checkbox"
        />
        <label className="custom-control-label" htmlFor="customer-subscribed">
          Keep me up to date on news and exclusive offers via email
        </label>
      </div>

      {currentLocation.canSubscribeViaSms ? (
        <div className="custom-control / custom-checkbox / checkout-contact-flow__checkbox">
          <input
            ref={register}
            className="custom-control-input"
            id="customer-subscribed-sms"
            name="subscribedSms"
            type="checkbox"
          />
          <label className="custom-control-label" htmlFor="customer-subscribed-sms">
            Keep me up to date on news and exclusive offers via text
          </label>
        </div>
      ) : null}

      {!loginState.isDisabled ? (
        <>
          {loginState.isOptional ? (
            <div className="form-group mb-1">
              <div className="custom-control / custom-checkbox / checkout-contact-flow__checkbox">
                <input
                  checked={wantPassword}
                  className="custom-control-input"
                  id="want-password"
                  type="checkbox"
                  onChange={toggleWantPassword}
                />
                <label className="custom-control-label" htmlFor="want-password">
                  Create an account for faster checkout
                </label>
              </div>
            </div>
          ) : null}

          <div className="checkout-contact-flow__field-group" hidden={!(loginState.isRequired || wantPassword)}>
            <hr />
            <PasswordField
              autoComplete="new-password"
              label={
                loginState.isRequired
                  ? 'Accounts are required to checkout. Please create a password'
                  : 'Please create a password'
              }
              required={loginState.isRequired || wantPassword}
              wrapperClassName="form-group mb-0"
            />
          </div>
        </>
      ) : null}
    </div>
  )
}

export default Details
